import React from "react"
import styled from "styled-components"
import { Modal } from "react-bootstrap"
import Image from "gatsby-image"

const StyledModal = styled.div`
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`

function ImageModal({ imageFluid, title = "" }) {
  const [show, setShow] = React.useState(false)

  const handleOpen = () => setShow(true)
  const handleClose = () => setShow(false)

  return (
    <>
      <StyledModal onClick={handleOpen}>
        <Image fluid={imageFluid} className="card-image" alt="1" />
      </StyledModal>

      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Image fluid={imageFluid} alt="Modal" className="image" />
        </Modal.Body>
      </Modal>
    </>
  )
}

export default ImageModal
